export default __webpack_public_path__ + "static/media/send.67a8e558.svg";